import type { FC } from "react"
import { useCreation } from "ahooks"
import classNames from "classnames"
import SVG from "react-inlinesvg"
import "./index.scss"
// ==============================================
interface SvgIconProps {
  src: string
  className?: string
  color?: string
  pointer?: boolean
  title?: string
  onClick?: () => void
}
const SvgIcon: FC<SvgIconProps> = ({
  src,
  className = "",
  color,
  pointer = false,
  title = "",
  onClick,
}) => {
  const spanStyle = useCreation(() => {
    const values: any = {}
    if (color) {
      values.color = color
    }
    if (pointer) {
      values.cursor = "pointer"
    }

    return values
  }, [color, pointer])

  const svgProps = useCreation(() => {
    const values: any = {}
    if (title) {
      values.title = title
    }

    return values
  }, [title])

  return (
    <span className={classNames("custom-svg-icon", className)} style={spanStyle} onClick={onClick}>
      <SVG {...svgProps} src={src} />
    </span>
  )
}

export default SvgIcon
